export var SecurityAccountSubject;
(function (SecurityAccountSubject) {
    SecurityAccountSubject["CreateSecurityAccount"] = "create-security-account-success";
    SecurityAccountSubject["DeleteSecurityAccount"] = "delete-security-account-success";
    SecurityAccountSubject["UpdateSecurityAccount"] = "update-security-account-success";
})(SecurityAccountSubject || (SecurityAccountSubject = {}));
//# sourceMappingURL=manage-security-accounts.enum.js.map